import $ from 'jquery';
import ScrollMagic from "ScrollMagic";
import 'debug.addIndicators';
import { Power1, Power0, Power4, TimelineMax, TweenMax, Linear } from "gsap/TweenMax";


export default () => {

    // init controller
    let controller = new ScrollMagic.Controller();

    let animazione_tenda = () => {
        let images = $('.img-wrapper');
        images.each((i, el) => {
            let height = $(el).find('img').height();
            let width = $(el).find('img').width();

            var css = {
                'width': 0 + 'px',
                'height': height + 'px'
            };
            // console.log(css);
            $(el).css(css);


            let css_wrapper = {
                "width": width + 'px',
                "background-size": width + 'px ' + height + 'px',
            };

            setTimeout(() => {
                new ScrollMagic.Scene({
                    triggerElement: el,
                    triggerHook: 0.95,
                    reverse: false
                })
                    .addTo(controller)
                    // .addIndicators({name: `Animage ${i} Trigger`})
                    .on("enter", (e) => {
                        let element = $(e.target.triggerElement());
                        i == 0 ? setTimeout(() => element.css(css_wrapper).addClass('play'), 700) : element.css(css_wrapper).addClass('play');
                    });
            }, 300);
        });
    };


    let animazione_testi = () => {
        let images = $('section');
        images.each((i, el) => {

            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: false
            })
                .addTo(controller)
                //.addIndicators({name: `Animage ${i} Testi`})
                .on("enter", (e) => {
                    let element = $(e.target.triggerElement());
                    let tags = element.find(".animate");

                    // tags.each((i, el) => {

                    let velocity = 0.1;
                    if ($(window).width() > 768) {
                        velocity = 0.5;
                    }
                    TweenMax.staggerFromTo(tags, velocity * tags.length, { y: '30px', autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power4.easeOut }, 0.2);
                    // });
                });
        });
    };


    let animazione_righetta = () => {
        if ($(".righetta").length > 0) {
            var scene = new ScrollMagic.Scene({
                triggerElement: ".righetta",
                duration: 800,
                triggerHook: 0.75
            })
                .setTween(".righetta .height", { height: "400px" })
                //.addIndicators({name: "2 (duration: 300)"})
                .addTo(controller);
        }
    };

    let animazione_parallax_image = () => {

        if ($('.parallax-image').length > 0 && $(window).width() > 768) {

            var tweenHiws = new TimelineMax()
                .add('parallax')
                .to(".parallax-image .img-parallax-1", 2, { y: -100, ease: Linear.easeOut }, 'parallax')
                .fromTo(".parallax-image .img-parallax-2", 3, { y: -250 }, { y: -100, ease: Linear.easeOut }, 'parallax')
                .to(".parallax-image .img-parallax-3", 1, { y: -100, ease: Linear.easeOut }, 'parallax');

            var sceneHiws = new ScrollMagic.Scene({
                triggerElement: ".parallax-image",
                duration: '100%',
                triggerHook: 0.6
            })
                .setTween(tweenHiws)
                // .addIndicators()
                .addTo(controller);
        }
    };

    $(window).on('load', function () {
        animazione_parallax_image();
        animazione_righetta();
    });
    $(document).on("older_age_complete", function () {
        animazione_testi();
        animazione_tenda();
    });
};



// WEBPACK FOOTER //
// ./scripts/libs/animage.js